<div class="inner-wrapper flex-fill">
  <ng-content></ng-content>
</div>
